import {
    Component,
    Input
}                                     from '@angular/core';

import { ElementInfoComponent }       from '../../element/element/element-info.component';
import { TableDataComponent }         from '@GuiElements/table-data.component';
import {
    MobileCellSignalQualityComponent,
    MobileCellSignalStrengthComponent
}                                     from '@MobileCells/MobileCell/elements/';

import { MobileCellGsmCommon }        from './';


@Component({
    selector:     'qp-mobile-cell-gsm-info',
    templateUrl:  'mobile-cell-gsm-info.component.html',
    styleUrls:   [
        'mobile-cell-gsm-info.component.css'
    ],
    imports:     [
        // MobileCellSignalQualityComponent,
        // MobileCellSignalStrengthComponent,
        TableDataComponent
    ]
})
export class MobileCellGsmInfoComponent extends ElementInfoComponent
{
    @Input()
    public cell:       MobileCellGsmCommon;

    @Input()
    public nullValues: boolean              = true;


    //
    // Getters
    //
    get d(): any
    {
        return this.cell;
    }

    // get d(): MobileCellGsmCommon
    // {
    //     return this.cell as MobileCellGsmCommon;
    // }
}